"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function TicketIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("rect", { x: "13.777", y: "9.324", width: "1.699", height: "5.351" }),
        react_1.default.createElement("path", { d: "M22.512,9.269a.85.85,0,0,0,.754-.845V6.33a2.853,2.853,0,0,0-2.849-2.85H3.583A2.853,2.853,0,0,0,.734,6.33V8.424a.85.85,0,0,0,.754.845,2.709,2.709,0,0,1,0,5.388.85.85,0,0,0-.754.845V17.67a2.853,2.853,0,0,0,2.849,2.85H20.417a2.853,2.853,0,0,0,2.849-2.85V15.5a.85.85,0,0,0-.754-.845,2.709,2.709,0,0,1,0-5.388ZM21.567,16.2V17.67a1.152,1.152,0,0,1-1.15,1.15H15.476V16.628h-1.7V18.82H3.583a1.152,1.152,0,0,1-1.15-1.15V16.2a4.407,4.407,0,0,0,0-8.465V6.33a1.152,1.152,0,0,1,1.15-1.15H13.777V7.372h1.7V5.18h4.941a1.152,1.152,0,0,1,1.15,1.15v1.4a4.407,4.407,0,0,0,0,8.465Z" })));
}
exports.default = TicketIcon;
